import React from 'react';

export default function PrivacyPage() {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12 pt-24 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">Adatkezelési Tájékoztató</h1>
      <div className="prose text-gray-700 space-y-4">
        <p>Jelen tájékoztató célja, hogy bemutassa a weboldal (mosolytorna.hu) adatkezelési gyakorlatát a GDPR rendeletnek megfelelően.</p>

        <h2 className="text-xl font-semibold mt-6">1. Az Adatkezelő adatai</h2>
        <p><strong>Név:</strong> Peredi Krisztina<br />
        <strong>E-mail:</strong> kriszta.peredikukacgmail.com</p>

        <h2 className="text-xl font-semibold mt-6">2. Kezelt adatok köre és célja</h2>
        <ul className="list-disc pl-5">
          <li className="mb-2"><strong>Kapcsolatfelvétel:</strong> Ha e-mailben vagy telefonon megkeresel, az általad megadott adatokat (név, e-mail cím, telefonszám) kizárólag a kapcsolatfelvétel és válaszadás céljából kezeljük. Jogalap: az érintett önkéntes hozzájárulása.</li>
          <li><strong>Sütik (Cookies) és analitika:</strong> A weboldal a Vercel Analytics és Speed Insights szolgáltatásait használja anonimizált statisztikai adatok gyűjtésére (pl. látogatók száma, oldalbetöltési sebesség). Ezek az adatok nem alkalmasak személyazonosításra. Erre az oldal alján lévő süti sávon (cookie banner) adhatod meg a hozzájárulásod.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-6">3. Az adatkezelés időtartama</h2>
        <p>A kapcsolatfelvétel során megadott adatokat az ügy elintézéséig, de legfeljebb a hozzájárulásod visszavonásáig kezeljük. A statisztikai célú sütik élettartama a böngésző bezárásáig vagy a felhasználó általi törlésig tart.</p>

        <h2 className="text-xl font-semibold mt-6">4. Az érintettek jogai és jogorvoslat</h2>
        <p>Bármikor jogosult vagy tájékoztatást kérni a rólad kezelt személyes adatokról, kérheted azok helyesbítését vagy törlését az adatkezelő e-mail címén. Továbbá panasszal élhetsz a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH - 1055 Budapest, Falk Miksa utca 9-11., ugyfelszolgalat@naih.hu).</p>
      </div>
    </div>
  );
}
